import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=69e904b0"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e904b0')) {
      api.createRecord('69e904b0', component.options)
    } else {
      api.reload('69e904b0', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=69e904b0", function () {
      api.rerender('69e904b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/views/Dashboard.vue"
export default component.exports